class ComponentMenuDropdown extends Theme.Component {

  connectedCallback() {
    this.preloadProductImages();
    this.events();
  }

  preloadProductImages() {
    if (!window.matchMedia("(pointer: fine)").matches) {
      return;
    }

    this.elements.product_links.forEach((element) => {
      const url = element.dataset.imageUrl;
      const img = new Image();

      img.src = url;
    });
  }

  updateProductImage(detail, element) {
    this.elements.product_image.src = element.dataset.imageUrl;
  }
}

customElements.define("component-menu-dropdown", ComponentMenuDropdown);
